"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1({ product, productIndex, }) {
    const { room: roomId, id: productId, images, name, origin_price, price, stock, purchase_limit, total_order_quantity: minStock, isFreeFormData, } = product;
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [copyCount, setCopyCount] = (0, react_1.useState)(1);
    const clone = {
        name: `${name}_${copyCount}`,
        origin_price,
        price: isFreeFormData && origin_price !== 0 ? price + 500 : price,
        stock: stock || 0,
        purchase_limit,
    };
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const checkPromiseEditModal = () => {
        if (isFreeFormData && !isDemandSurvey) {
            dispatch((0, roomCreateStore_1.setOpenPromiseEditModal)(true));
        }
    };
    const productLength = (0, react_redux_1.useSelector)((state) => state.productData).length;
    const isProductDuplicable = !isDemandSurvey || (isDemandSurvey && productLength < 50);
    const isProductDeletable = productLength !== 1 && !Boolean(minStock);
    const [duplicating, setDuplicating] = (0, react_1.useState)(false);
    const duplicateAction = () => {
        if (isProductDuplicable) {
            setDuplicating(true);
            dispatch((0, roomCreateStore_1.duplicateProduct)({ roomId, clone, setDuplicating }));
            setCopyCount(copyCount + 1);
        }
        else
            (0, functions_1.showToastMessage)({ message: t('최대 50개까지 추가할 수 있어요') });
    };
    const defaultValues = {
        name,
        origin_price: Boolean(origin_price) ? origin_price : '',
        stock: Number(stock) > 9999 ? 9999 : Boolean(stock) ? stock : '',
        purchase_limit: Number(purchase_limit) > 9999 ? 9999 : Boolean(purchase_limit) ? purchase_limit : '',
    };
    const shouldAskBeforeDelete = () => {
        let userInputExist = false;
        if (images.length) {
            userInputExist = true;
        }
        else {
            const inputsArr = Object.values(defaultValues);
            inputsArr.forEach(input => {
                if (Boolean(input)) {
                    userInputExist = true;
                    return false;
                }
            });
        }
        return userInputExist;
    };
    const [deleting, setDeleting] = (0, react_1.useState)(false);
    const removeAction = () => {
        setDeleting(true);
        dispatch((0, roomCreateStore_1.removeProduct)({ roomId, productId, setDeleting, productIndex }));
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const confirmRemoveProduct = () => {
        if (shouldAskBeforeDelete()) {
            confirm({ description: t('작품을 삭제하시겠습니까?') })
                .then(removeAction)
                .catch(() => { });
        }
        else {
            removeAction();
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '16px',
            padding: '14px',
            border: '1px solid var(--gray-5)',
            borderRadius: '12px',
            marginTop: '10px',
            boxShadow: '0px 2px 4px var(--gray-5)',
        } }, { children: [(0, jsx_runtime_1.jsx)(_1.ProductUpdatePhotos, { roomId: roomId, productId: productId }), (0, jsx_runtime_1.jsx)(_1.ProductUpdateInfos, { defaultValues: defaultValues, productIndex: productIndex, minStock: minStock || 1 }), isProductDeletable ? (deleting ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: {
                    position: 'absolute',
                    top: '-4.5px',
                    right: '-4.5px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--gray-20)',
                } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 10, color: "info", thickness: 8 }) }))) : ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: confirmRemoveProduct, css: { position: 'absolute', top: '-8.5px', right: '-8.5px' } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: {
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        backdropFilter: 'blur(10px)',
                    } }) })))) : null, (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                        height: '28px',
                        p: '0 12px',
                        border: '1px solid var(--gray-10)',
                        borderRadius: '6px',
                        marginTop: '-6px',
                        bgcolor: 'var(--white) !important',
                        color: 'var(--gray-80)',
                        float: 'right',
                    }, disabled: duplicating || deleting, onClick: () => {
                        checkPromiseEditModal();
                        duplicateAction();
                    } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 gray-80" }, { children: t('복제') })) })) })] })));
}
exports.default = default_1;
